import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4fb1e3a0&scoped=true&fluid=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1e3a0",
  null
  
)

export default component.exports